/* eslint-disable react/react-in-jsx-scope */

import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";

import { useTranslation } from "react-i18next";

import { ChevronLeft } from "lucide-react";
import { useEffect, useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { resendCodeConfirmation } from "../services/authService";

const ReverificationForm = () => {
  const { user, loading, logout } = useAuth();
  const [disabledRenvoi, setDisabledRenvoi] = useState(false);

  const { t } = useTranslation("auth", {
    keyPrefix: "reverification",
  });

  useEffect(() => {
    if (!loading && !user) {
      window.location.href = "/login";
    }
    console.log("user", user);
    if (!loading && user?.isVerified) {
      window.location.href = "/dashboard";
    }
  }, [loading]);

  // useEffect(() => {
  //   if (!user) {
  //     window.location.href = "/login";
  //   }
  // }, [user]);

  const resendCode = async () => {
    setDisabledRenvoi(true);
    resendCodeConfirmation().then((res) => {
      setDisabledRenvoi(false);
      window.location.href = `/register/verify`;
    });
  };

  if (loading || !user || user.isVerified) {
    return (
      <div className=" m-14 text-center min-h-60 flex justify-center flex-col items-center">
        <Skeleton className="h-8 md:h-12 w-3/4 max-w-[520px] mb-6" />
        <div className="w-full max-w-[700px] space-y-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-11/12 mx-auto" />
          <Skeleton className="h-4 w-10/12 mx-auto" />
        </div>
        <Skeleton className="h-10 w-48 mt-6 rounded-md" />
        <Skeleton className="h-6 w-64 mt-4 rounded-md" />
      </div>
    );
  }
  return (
    <>
      <div className=" m-14 text-center min-h-60 flex justify-center flex-col items-center false">
        <h1 className="text-xl md:text-4xl mb-4 font-black text-destructive ">
          {t("Votre compte n’est pas encore confirmé")}
        </h1>
        <p>
          {t(
            "Il semble que votre inscription ne soit pas encore finalisée. Pour accéder à votre compte, vous devrez d’abord renseigner le code de confirmation qui sera envoyé à votre adresse e-mail.",
          )}
          <br />
          {t(
            "En cliquant sur Renvoyer le code, un nouvel e-mail de confirmation vous sera envoyé, puis vous serez automatiquement redirigé vers la page de saisie du code.",
          )}
        </p>
        <Button disabled={disabledRenvoi} onClick={resendCode} className="my-4">
          {t("Renvoyer le code")}
        </Button>

        <Button
          onClick={() => {
            logout();
          }}
          className="  bg-transparent inline-flex items-center gap-1 text-sm text-primary underline hover:text-primary/80 transition-colors"
        >
          <ChevronLeft />
          {t("Retour à la page de connexion")}
        </Button>
      </div>
    </>
  );
};

export default ReverificationForm;
